module.exports = __webpack_public_path__ + "static/media/thumb-otros.dae0b0f8.png";